module.exports = __webpack_public_path__ + "img/logo.796e6faf.png";